import { archiverEnMasse } from '@/api/tiers';

export default async function archiverTiers(props, status) {
  const listeIdClients = [];
  props.forEach((client) => {
    listeIdClients.push(client.id);
  });
  const params = {
    ids: listeIdClients,
    archiver: !status,
  };
  await archiverEnMasse(params);
}
